import styled from '@emotion/styled';

import { IconColor } from 'app/components/v3/components/Icon/helpers';

import Icon, { IconSize } from './Icon';

// Local Typings
interface Props {
  iconColor?: IconColor;
  iconSize?: IconSize;
}

// Local Variables
const StyledIcon = styled(Icon)({
  // eslint-disable-next-line @typescript-eslint/naming-convention
  '@keyframes spin': {
    from: {
      transform: 'rotate(0deg)',
    },
    to: {
      transform: 'rotate(360deg)',
    },
  },
});
const StyledDiv = styled.div({
  animation: 'spin 0.7s linear infinite',
  display: 'inline-flex',
  width: 'fit-content',
});

// Component Definition
const LoadingSpinner: React.FC<Props> = props => (
  <StyledDiv
    className="loading-spinner"
    data-testid="loadingSpinner"
  >
    <StyledIcon
      color={props.iconColor ?? 'neutral'}
      name="old-loading"
      size={props.iconSize}
    />
  </StyledDiv>
);

export default LoadingSpinner;
